import { md5 } from 'js-md5'
import { apiClient, requestData } from '@/api/client'
import type { ApiResponse } from '@/types/api'
import type { LoginPayload, LoginResult } from '@/types/auth'

export function login(payload: LoginPayload): Promise<LoginResult> {
  return requestData(
    apiClient.post<ApiResponse<LoginResult>>('/business/tbk/login/user/login', payload),
  )
}

export async function logout(): Promise<void> {
  await requestData(apiClient.get<ApiResponse<unknown>>('/business/tbk/login/exit'))
}

export interface ChangePasswordPayload {
  currentPassword: string
  newPassword: string
}

export async function changePassword(payload: ChangePasswordPayload): Promise<void> {
  await requestData(
    apiClient.post<ApiResponse<unknown>>('/business/tbk/login/update', {
      password: md5(payload.currentPassword),
      newPwd: md5(payload.newPassword),
    }),
  )
}
